module.exports = {
          srcSet: __webpack_public_path__ + "assets/81f7cc056b831d6134691c0a54ef097f.jpg"+" 84w",
          images:[ {path: __webpack_public_path__ + "assets/81f7cc056b831d6134691c0a54ef097f.jpg",width: 84,height: 84}],
          src: __webpack_public_path__ + "assets/81f7cc056b831d6134691c0a54ef097f.jpg",
          toString:function(){return __webpack_public_path__ + "assets/81f7cc056b831d6134691c0a54ef097f.jpg"},
          
          width: 84,
          height: 84
        }